const slideToggle = (target, duration = 500) => {
  if (window.getComputedStyle(target).display === 'none') {
    return slideDown(target, duration);
  } else {
    return slideUp(target, duration);
  }
}

class faqs extends HTMLElement {
  constructor() {
    super();
    this.clickEvent();
  }

  clickEvent = () => {
    let faqsItem = qsa('.faq-item', this);

    faqsItem.forEach(item => {
      let faqsItemButton = item.querySelector('.faq-item_title', this);

      faqsItemButton.addEventListener("click", () => {
        this.toggleContent(item);

        faqsItem.forEach(otherItem => {
          if (otherItem !== item && otherItem.classList.contains('active')) {
            this.toggleContent(otherItem);
          }
        });
      });
    })
  }

  toggleContent = (item) => {
    item.classList.toggle('active');
    let faqContent = qs('.faq_content',item);
    slideToggle(faqContent,300);
  }
}
customElements.define('section-faqs', faqs);